import { XStack } from 'tamagui';

import { RingGlyph } from '@/components/ring-glyph';
import { Text } from '@/components/text';

// A page ends on purpose: one quiet line under the last item says the content is
// finished, not missing. Distance ring at the margin, copy in the brand's warm,
// plain, slightly wry voice.
export function PageEnd({ children }: { children: string }) {
  return (
    <XStack alignItems="center" justifyContent="center" gap="$2" pt="$6" pb="$4">
      <XStack flexShrink={0}>
        <RingGlyph size={16} arcs={1} />
      </XStack>
      <Text color="$colorTertiary" fontSize="$meta" lineHeight="$meta" textAlign="center" flexShrink={1}>
        {children}
      </Text>
    </XStack>
  );
}
